import { Component, inject, signal } from "@angular/core";
import { APP_CONFIG_TOKEN } from "@kno2/core/config";
import { SessionService } from "@kno2/core/session";
import { DialogBodyComponent, DialogFooterComponent, DialogService } from "@kno2/shared/dialog";

@Component({
    selector: "kno2-account-organization-grace-period-modal",
    imports: [DialogBodyComponent, DialogFooterComponent],
    templateUrl: "./account-organization-grace-period-modal.component.html"
})
export class AccountOrganizationGracePeriodModalComponent {
    private readonly appConfig = inject(APP_CONFIG_TOKEN);
    private readonly sessionService = inject(SessionService);
    private readonly dialogService = inject(DialogService);

    protected readonly brandDisplayName = signal(this.appConfig.brandDisplayName);
    protected readonly finalDate = signal(this.sessionService.profileData()?.finalLoginDate);

    protected close(): void {
        this.dialogService.close();
    }
}
